/**
 * Diagnostic codé — référentiel maladies (1 consultation → n codes).
 */

export function extractNotesFromDiagnosis(diagnosis, diseases) {
  if (!diseases?.length) {
    return diagnosis ? String(diagnosis).trim() : '';
  }
  let text = diagnosis ? String(diagnosis).trim() : '';
  if (!text) return '';

  const coded = new Set();
  for (const d of diseases) {
    coded.add(`${d.code} — ${d.name}`.trim());
    coded.add(`${d.code} - ${d.name}`.trim());
  }

  const remaining = text.split('\n').filter((line) => !coded.has(line.trim()));
  return remaining.join('\n').trim();
}

/** @param {object|null} consultation */
export function parseDiseasesFromConsultation(consultation) {
  if (!consultation) {
    return { diseases: [], notes: '' };
  }

  if (Array.isArray(consultation.diseases) && consultation.diseases.length > 0) {
    return {
      diseases: consultation.diseases.map((d) => ({
        id: d.id,
        code: d.code,
        name: d.name
      })),
      notes: extractNotesFromDiagnosis(consultation.diagnosis, consultation.diseases)
    };
  }

  if (consultation.disease_id && consultation.disease_code) {
    const legacy = [
      {
        id: consultation.disease_id,
        code: consultation.disease_code,
        name: consultation.disease_name || ''
      }
    ];
    return {
      diseases: legacy,
      notes: extractNotesFromDiagnosis(consultation.diagnosis, legacy)
    };
  }

  return { diseases: [], notes: consultation.diagnosis || '' };
}

/** @param {{ id: number, code: string, name: string }[]} diseases */
export function buildDiagnosisApiPayload(diseases, notes) {
  const trimmedNotes = notes != null ? String(notes).trim() : '';
  const ids = (diseases || [])
    .map((d) => d.id)
    .filter((id) => id != null);

  if (!ids.length) {
    return {
      disease_ids: [],
      diagnosis_notes: trimmedNotes || null
    };
  }

  return {
    disease_ids: ids,
    diagnosis_notes: trimmedNotes || null
  };
}
